var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-tooltip',{ref:"buttonPresetsTooltipRef",attrs:{"content":_setup.props.tooltip,"disabled":!_setup.props.tooltip,"placement":_setup.props.tooltipPlacement,"hover":""}},[_c('ui-button',_vm._b({class:[
            'ui-button--presets',
            _setup.props.type === 'create' && '--hide-text',
            _setup.props.isActive && '--active',
        ],on:{"click":function($event){return _setup.emits('click')}}},'ui-button',_setup.getBind,false),[_vm._t("default",function(){return [(_setup.getText)?_c('span',[_vm._v(" "+_vm._s(_setup.getText)+" ")]):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }